import { AddIcon, ClearIcon } from "assets/icon";
import DialogModal from "components/DialogModal";
import { Field } from "formik";
import Utils from "utils";

function GinsengModal({
    openDialog,
    handleCloseDialog,
    intl,
    handleSubmit,
    initialValues,
    data,
    isAdd,
    validationSchema,
    filesImage,
    handleRemoveImage,
    handleOnchangeImage,
    onChangeFileCertificate,
    handleImage,
}) {
    return (
        <DialogModal
            openDialog={openDialog}
            handleCloseDialog={handleCloseDialog}
            handleSubmit={handleSubmit}
            validationSchema={validationSchema}
            initialValues={
                isAdd
                    ? initialValues
                    : {
                        id: data.id,
                        name: data.name,
                        code: data.code,
                        created_at: Utils.formatDateYDM(data.created_at),
                        source: data.source,
                        use_of_ginseng: data.use_of_ginseng,
                        other_information: data.other_information ?? "",
                        ginseng_certificates: Utils.getLastSplit(data.ginseng_certificates[0]?.file_path, '/', intl.messages.chooseFile),
                    }
            }
            headerTitle={
                isAdd ? intl.messages.createGinseng : intl.messages.updateGinseng
            }
            submitName={isAdd ? intl.messages.add : intl.messages.update}
            cancelName={intl.messages.cancel}
        >
            <div className="sub-header">{intl.messages.generalInformation}</div>
            <div style={{ display: "flex" }}>
                <div
                    className="input-container"
                    style={{ marginRight: "16px", width: "47%" }}
                >
                    <Field
                        className="input-container__input"
                        id="code"
                        name="code"
                        type="text"
                        placeholder={intl.messages.inputCode}
                    />
                    <label htmlFor="code" className="input-container__title required">
                        {intl.messages.ginId}
                    </label>
                </div>
                <div className="input-container">
                    <Field
                        className="input-container__input"
                        id="name"
                        name="name"
                        type="text"
                        placeholder={intl.messages.inputName}
                    />
                    <label htmlFor="name" className="input-container__title required">
                        {intl.messages.ginName}
                    </label>
                </div>
            </div>
            <div style={{ display: "flex", justifyContent: "space-between" }}>
                <div className="input-container">
                    <label className="link-label">
                        <Field name="created_at" htmlFor="created_at" >
                            {({ field }) => (
                                <>
                                    <span className="date-icon" />
                                    <span className="silver-text">{field.value}</span>
                                    <input className="input-container__input"
                                        id="created_at"
                                        type="date"
                                        style={{ display: "none" }} />
                                </>
                            )}
                        </Field>
                    </label>
                    <label
                        htmlFor="created_at"
                        className="input-container__title required"
                    >
                        {intl.messages.dateCreated}
                    </label>
                </div>
                <div
                    className="input-container"
                    style={{ marginRight: "16px", marginLeft: "16px" }}
                >
                    <Field
                        id="source"
                        name="source"
                        type="text"
                        className="input-container__input"
                        placeholder={intl.messages.inputSource}
                    />
                    <label htmlFor="source" className="input-container__title required">
                        {intl.messages.source}
                    </label>
                </div>
                <div className="input-container">
                    <label className="link-label" style={{ cursor: "pointer" }}>
                        <Field name="ginseng_certificates" htmlFor="ginseng_certificates">
                            {({ field }) => (
                                <>
                                    <span className="link-icon" />
                                    <span
                                        id="file-text"
                                        className={`${isAdd ? "silver-text" : "blue-text"}`}
                                    >
                                        {field.value}
                                    </span>
                                    <input
                                        className="input-container__input"
                                        id="ginseng_certificates"
                                        type="file"
                                        accept={"application/pdf"}
                                        onChange={onChangeFileCertificate}
                                        style={{ display: "none" }}
                                    />
                                </>
                            )}
                        </Field>
                    </label>
                    <label className={`input-container__title ${isAdd && `required`}`}>
                        {intl.messages.certificateOfGinseng}
                    </label>
                </div>
            </div>
            <div className="sub-header">{intl.messages.generalDetail}</div>
            <div style={{ display: "flex" }}>
                <div className="input-container" style={{ marginRight: "16px" }}>
                    <Field
                        className="input-container__input"
                        id="use_of_ginseng"
                        name="use_of_ginseng"
                        type="text"
                        placeholder={intl.messages.inputEffect}
                    />
                    <label
                        htmlFor="use_of_ginseng"
                        className="input-container__title required"
                    >
                        {intl.messages.useOfGinseng}
                    </label>
                </div>
                <div className="input-container">
                    <Field
                        className="input-container__input"
                        id="other_information"
                        name="other_information"
                        type="text"
                        placeholder={intl.messages.inputAnotherInformation}
                    />
                    <label htmlFor="other_information" className="input-container__title">
                        {intl.messages.AnotherInformation}
                    </label>
                </div>
            </div>
            <div className="card-container resize-height">
                <div style={{ display: "flex" }}>
                    {filesImage.map((item, index) => {
                        return (
                            <div style={{ position: "relative" }} key={`image-${index}`}>
                                <div
                                    className="remove-image-btn"
                                    onClick={() => handleRemoveImage(item)}
                                >
                                    <ClearIcon />
                                </div>
                                <img
                                    className="card-container__image-preview"
                                    src={handleImage(item)}
                                    alt={'error'}
                                />
                            </div>
                        );
                    })}
                    {filesImage.length < 5 && (
                        <div
                            className="upload-box"
                            onClick={() => document.getElementById("getFiles").click()}
                        >
                            <AddIcon />
                        </div>
                    )}
                </div>
                <input
                    accept="image/jpeg, image/png, image/jpg"
                    id="getFiles"
                    type="file"
                    style={{ display: "none" }}
                    onChange={handleOnchangeImage}
                />
                <label
                    className={`card-container__title ${filesImage.length < 1 && `required`}`}
                    style={{ marginBottom: "0px", color: "#3b927d" }}
                >
                    {intl.messages.avatarGinseng}
                </label>
            </div>
        </DialogModal>
    );
}

export default GinsengModal;
